<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12 col-lg-6 c g">
            <div class="card">
                <div class="card-body">
                    <div class="form-group">
                      <h5 for="">اسم المؤسسة / الشركة</h5>
                      <input type="text"
                        class="form-control" v-model="user.info.name" placeholder="أكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">رقم التسجيل الضريبي</h5>
                      <input type="text"
                        class="form-control" v-model="user.info.vat_number" placeholder="أكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">Seller ID</h5>
                      <input type="text"
                        class="form-control" v-model="user.info.seller_id" placeholder="أكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">Seller ID Type</h5>
                      <input type="text"
                        class="form-control" v-model="user.info.seller_id_type" placeholder="أكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">اسم الشارع</h5>
                      <input type="text"
                        class="form-control" v-model="user.info.street" placeholder="أكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">المدينة</h5>
                      <input type="text"
                        class="form-control" v-model="user.info.city" placeholder="أكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">المبنى</h5>
                      <input type="text"
                        class="form-control" v-model="user.info.building" placeholder="أكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">الحي</h5>
                      <input type="text"
                        class="form-control" v-model="user.info.district" placeholder="أكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">رمز الدولة</h5>
                      <input type="text"
                        class="form-control" v-model="user.info.country_code" placeholder="أكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">الرمز البريدي</h5>
                      <input type="text"
                        class="form-control" v-model="user.info.postal_code" placeholder="أكتب هنا...">
                    </div>
                    <div class="col-12 text-center g" @click="save()">
                        <button class="btn btn-primary">حفظ الإعدادات</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput } from "bootstrap-vue";
export default {
  components: {
    // Layouts
    BModal,BFormInput},
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  data(){
    return {
        user: JSON.parse(localStorage.getItem('user')),
    }
  },
  created(){
    var g = this;
  },
  methods: {
    save(){
        var g = this;
        $.post(api + '/user/web/settings-save', {jwt: g.user.jwt, info: g.user.info}).then(function(r){
            if(r.status == 100){
                location.reload()
            }else{
                alert(r.response, 200)
            }
        }).fail(function(){
            alert('تعذر الاتصال بالخادم')
        })
    }
  }

}
</script>

<style>
.text-right input{
    text-align: right;
}
</style> 